module.exports = __webpack_public_path__ + "static/media/consultation.65bb2a29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/consultation.jpg
// module id = 870
// module chunks = 8